import React from "react";
import moment from "moment";
import { useContext } from "../../context";
import { AdditionalProvider } from "./AdditionalProvider";
import { BookedBy } from "./BookedBy";
import { BookingDate } from "./BookingDate";
import { Clinic } from "./Clinic";
import { Confirmation } from "./Confirmation";
import { Consents } from "./Consents";
import { DateTime } from "./DateTime";
import { Email } from "./Email";
import { EndsAt } from "./EndsAt";
import { LastCancelled } from "./LastCancelled";
import { MedicalProvider } from "./MedicalProvider";
import { Notes } from "./Notes";
import { Patient } from "./Patient";
import { Phone } from "./Phone";
import { Questionnaires } from "./Questionnaires";
import { Services } from "./Services";
import { Source } from "./Source";
import GfeClientDetails from "./GfeClientDetails/GfeClientDetails";

export function DetailRows({ refetchAppointments }) {
  const { appointment, gfeToggle } = useContext();

  const rows = [
    {
      id: "patient",
      component: Patient,
      isVisible: true,
    },
    {
      id: "bookingDate",
      component: BookingDate,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "bookedBy",
      component: BookedBy,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "email",
      component: Email,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "phone",
      component: Phone,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "gfeClientDetails",
      component: GfeClientDetails,
      isVisible: gfeToggle.value !== null,
    },
    {
      id: "source",
      component: Source,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "notes",
      component: Notes,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "consents",
      component: Consents,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "questionnaires",
      component: Questionnaires,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "clinic",
      component: Clinic,
      isVisible: true,
    },
    {
      id: "medicalProvider",
      component: MedicalProvider,
      isVisible: true,
    },
    {
      id: "additionalProvider",
      component: AdditionalProvider,
      isVisible:
        !appointment.isAdditionalProviderAppointment &&
        appointment.appointmentType === "virtual",
    },
    {
      id: "services",
      component: Services,
      isVisible: true,
    },
    {
      id: "dateTime",
      component: DateTime,
      isVisible: true,
    },
    {
      id: "endTime",
      component: EndsAt,
      isVisible: true,
    },
    {
      id: "confirmation",
      component: Confirmation,
      isVisible:
        moment().format("YYYY-MM-DD HH:mm:ss") <= appointment.date &&
        !appointment.isAdditionalProviderAppointment,
    },
    {
      id: "lastCancelled",
      component: LastCancelled,
      isVisible: !appointment.isAdditionalProviderAppointment,
    },
  ].filter((row) => row.isVisible);

  return (
    <div className="event-detail-outer m-b-15">
      {rows.map((row) => (
        <row.component key={row.id} refetchAppointments={refetchAppointments} />
      ))}
    </div>
  );
}
